module.exports = __webpack_public_path__ + "img/cases-brand-suning-lazyload-01.777ac651.jpg";